// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__w3Pt1","content":"LayoutSettings_content__1Kxfh"};